import React from 'react';
import { Globe, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Big, obvious language toggle. Instead of a dropdown, it shows the OTHER
 * language as a direct call-to-action so non-tech-savvy visitors can
 * clearly see how to switch.
 *   - When site is in English → button reads "🇲🇽 Español · Click aquí"
 *   - When site is in Spanish → button reads "🇺🇸 English · Click here"
 */
const LanguageSwitcher = () => {
  const { lang, setLang, translating } = useLanguage();

  const isEs = lang === 'es';
  const target = isEs ? 'en' : 'es';

  // Content shown on the button (what you'll switch TO)
  const flag = isEs ? '🇺🇸' : '🇲🇽';
  const primary = isEs ? 'English' : 'Español';
  const helper = isEs ? 'Click here' : 'Haz clic aquí';

  const handleClick = () => setLang(target);

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="language-switcher-btn"
      data-no-translate="true"
      translate="no"
      aria-label={isEs ? 'Switch to English' : 'Cambiar a Español'}
      className="flex items-center gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-full transition-all hover:scale-[1.04] active:scale-[0.97] shadow-lg"
      style={{
        background: 'linear-gradient(135deg, #D4A373 0%, #B5895F 100%)',
        color: '#0C0A09',
        boxShadow: '0 4px 20px rgba(212, 163, 115, 0.35)',
      }}
    >
      {translating ? (
        <Loader2 className="h-4 w-4 sm:h-5 sm:w-5 animate-spin" />
      ) : (
        <Globe className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={2.5} />
      )}
      <span className="text-lg sm:text-xl leading-none" aria-hidden="true">
        {flag}
      </span>
      <span className="flex flex-col items-start leading-tight">
        <span className="text-sm sm:text-base font-extrabold uppercase tracking-wide">
          {primary}
        </span>
        <span
          className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.15em]"
          style={{ opacity: 0.75 }}
        >
          {helper}
        </span>
      </span>
    </button>
  );
};

export default LanguageSwitcher;
